<template>
  <div class="app">
    <component :is="Header"></component>
    <section class="home_simulator" ref="simulator_start">
      <main>
        <component :is="MainContent"></component>  
      </main>
    </section>
    <component :is="Footer"></component>  
  </div>
</template>

<script>
// @ is an alias to /src

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MainContent from '@/components/MainContent.vue'

export default {
  component: {
    Header,
    Footer,
    MainContent
  },
  computed: {
    Header() {
      return Header
    },
    Footer() {  
      return Footer
    },
    MainContent() {
      return MainContent
    }
  },
  mounted() {
    document.title = "今すぐ借金を減額したい方、まずはLINEから無料診断！｜弁護士法人ラピス法律事務所";
    document.querySelector("meta[name='description']").setAttribute('content', "借りたお金の返済で苦労している、月々の返済額を減らしたい…。LINE診断で、あなたの借金を減らせる可能性を診断しましょう。ご利用や相談は無料で承っております。")
    document.querySelector("meta[name='robots']").setAttribute('content', "noindex, nofollow, noarchive")
  },
  created() {
    (function(){
    var cats_gid=5;
    var organic_cid="";
    var can_organic_search="off";
    var can_chatbot="off";
    var cats_options={
    api_parameter_inheritance: "on",
    lineFriendsFollow: {
    useId: 16,
    loginCallbackUrlDomain: "wbridge.ac01.l-ad.net",
    liffId: "2008396272-GYJWDLnE",
    line_crm: {}
    }
    };
    var a=document.createElement("script");
    a.src="//wbridge.ac01.l-ad.net/ck/p1986r365828deef/cookie.js";
    // a.src="//wbridge.ac01.l-ad.net/ck/p1986r365828deef/group.js";
    a.id="ck_p1986r365828deef"; 
    // eslint-disable-next-line
    a.addEventListener("load",function(){CATS_GroupCreate(cats_gid,"p1986r365828deef", organic_cid, can_organic_search, can_chatbot, cats_options);});
    document.body.appendChild(a);
    })();
  }
}
</script>

<style scoped lang="scss">
@import "~@/Resources/styles.scss";
</style>
